export default {
  online_shop: 'Online shop',
  storefront: 'Storefront',
  reservations: 'Reservations',
  import: 'Import',
};
